import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection } from "firebase/firestore";
import { safeOnSnapshot } from "../lib/safeSnapshot";
import { db } from "../firebaseConfig";
import { FaUserTag, FaCheck } from "react-icons/fa";
import { useAuth } from "../contexts/AuthContext";
import { useActiveCargo } from "../lib/activeCargo";
import { fetchRoleTabs } from "../hooks/useRoleTabs";

// Seletor de CARGO (para colaborador multi-cargo). Renderiza a seção "Trocar
// cargo" no dropdown da engrenagem, ao lado do seletor de perfil. Trocar o
// cargo muda as abas/menu/dashboards (cargo ativo) e leva à 1ª aba dele.
// Retorna null quando o colaborador tem 1 cargo ou nenhum.
const CargoSwitcher = ({ onNavigate }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { activeCargo, setActiveCargo, cargos } = useActiveCargo();
  const [labels, setLabels] = useState({});

  useEffect(() => {
    if (cargos.length <= 1) return undefined;
    const unsub = safeOnSnapshot(
      collection(db, "employee_types"),
      (snap) => {
        const m = {};
        snap.docs.forEach((d) => {
          const t = d.data();
          if (t.value) m[t.value] = t.label || t.value;
        });
        setLabels(m);
      },
      { label: "employee_types" }
    );
    return () => unsub();
  }, [cargos.length]);

  if (cargos.length <= 1) return null;

  const pick = async (cargo) => {
    if (onNavigate) onNavigate();
    if (cargo === activeCargo) return;
    setActiveCargo(cargo);
    try {
      const tabs = await fetchRoleTabs(cargo, user?.perms);
      navigate(tabs?.[0]?.route || "/employee/files");
    } catch {
      navigate("/employee/files");
    }
  };

  return (
    <div className="border-b border-slate-100 mb-1 pb-1">
      <p className="px-3 pt-1 pb-1 text-[11px] uppercase tracking-wide text-slate-400 font-semibold">
        Trocar cargo
      </p>
      {cargos.map((cargo) => {
        const active = cargo === activeCargo;
        return (
          <button
            key={cargo}
            onClick={() => pick(cargo)}
            className={`flex items-center w-full px-3 py-2 text-sm transition-colors duration-200 ${
              active ? "bg-blue-50 text-blue-700 font-medium" : "text-slate-600 hover:bg-slate-50"
            }`}
          >
            <FaUserTag className={`w-4 h-4 mr-2.5 ${active ? "text-blue-600" : "text-slate-400"}`} />
            <span className="flex-1 text-left">{labels[cargo] || cargo}</span>
            {active && <FaCheck className="w-3 h-3 text-blue-600" />}
          </button>
        );
      })}
    </div>
  );
};

export default CargoSwitcher;
